import * as clientErrTypes from 'config/clientErrorTypes';

/**
 * 檢查錯誤是否為點數被上鎖錯誤
 * @typedef {Function} CHECK_POINT_IS_LOCKED
 * processing - 1 => 檢查鎖時發現有鎖噴錯
 * processing - 2 => 上鎖時，如果有鎖就會噴錯
 */
export const CHECK_POINT_IS_LOCKED = resp =>
    resp.httpStatus === 400 &&
    resp?.payload?.code === 'PSM-V0-F0' &&
    (resp?.payload?.message === 'Data processing - 1' ||
        resp?.payload?.message === 'Data processing - 2');

export const REDEEM_POINT_API_RESPONSE = {
    [clientErrTypes.REDEEM_POINT_IS_NOT_ENOUGH]: r =>
        r.httpStatus === 400 &&
        r?.payload?.code === 'PSM-V0-F0' &&
        r?.payload?.message === 'Member points is not enough',
    [clientErrTypes.REDEEM_POINT_FAILED]: r => r.httpStatus !== 200
};
